// File: src/EnglishTool/StoryModeStructure.js

import React, { useState, useEffect } from "react";
import defaultProfile from "../../UserProfile/EmptyProfile.jpg";

export function StoryModeMultipleChoice({
  cQ,
  onAnswerClick,
  currentScore,
  quizLength,
  user,
  lastFeedback,
  setLastFeedback
}) {
  return (
    <div className="quick-quiz-story-mode">
      <div className="quiz-top-panel">
        <div className="teacher-image-container">
          <img
            src="/images/Teacher.png"
            alt="Teacher"
            className="quiz-character-img"
          />
        </div>
        <div className="quiz-question-box">
          <p className="quiz-question-text">{cQ.question}</p>
        </div>
      </div>
      <div className="quiz-bottom-panel">
        <div className="quiz-answer-box-left">
          {cQ.options.map((opt, idx) => (
            <button
              key={idx}
              className="quiz-answer-btn"
              onClick={() => onAnswerClick(opt)}
              disabled={lastFeedback && !lastFeedback.isCorrect}
            >
              {opt}
            </button>
          ))}
        </div>
        <div className="student-image-container">
          <img
            src={user?.avatar ?? defaultProfile}
            alt="Student"
            className="quiz-character-img-student"
          />
        </div>
      </div>
      {lastFeedback && (
        <div
          style={{
            marginTop: 8,
            padding: 8,
            borderRadius: 8,
            background: lastFeedback.isCorrect ? "#e0ffe0" : "#fff0f0"
          }}
        >
          {lastFeedback.isCorrect ? (
            <b style={{ color: "#228833" }}>Correct!</b>
          ) : (
            <>
              <b style={{ color: "#c33" }}>Not quite.</b>
              <div>
                The correct answer was: <b>{lastFeedback.correctAnswer}</b>
              </div>
              <button
                className="button1"
                style={{ marginTop: 8 }}
                onClick={() => setLastFeedback(null)}
              >
                Try Again
              </button>
            </>
          )}
        </div>
      )}
      <p className="quiz-score-display">
        Score: {currentScore}/{quizLength}
      </p>
    </div>
  );
}

export function StoryModeFillInBlank({
  cQ,
  onSubmit,
  currentScore,
  quizLength,
  user,
  lastFeedback,
  setLastFeedback
}) {
  const [userInput, setUserInput] = useState("");
  function handleSubmit() {
    onSubmit(userInput);
  }
  return (
    <div className="quick-quiz-story-mode">
      <div className="quiz-top-panel">
        <div className="teacher-image-container">
          <img
            src="/images/teacher.png"
            alt="Teacher"
            className="quiz-character-img"
          />
        </div>
        <div className="quiz-question-box">
          <p className="quiz-question-text">{cQ.question}</p>
        </div>
      </div>
      <div className="quiz-bottom-panel">
        <div className="quiz-answer-box-left">
          <input
            type="text"
            value={userInput}
            onChange={e => setUserInput(e.target.value)}
            placeholder="Type your answer"
            className="quiz-input"
            disabled={lastFeedback && !lastFeedback.isCorrect}
          />
          <button
            className="quiz-answer-btn"
            onClick={handleSubmit}
            disabled={lastFeedback && !lastFeedback.isCorrect}
          >
            Submit
          </button>
        </div>
        <div className="student-image-container">
          <img
            src={user?.avatar ?? defaultProfile}
            alt="Student"
            className="quiz-character-img-student"
          />
        </div>
      </div>
      {lastFeedback && (
        <div
          style={{
            marginTop: 8,
            padding: 8,
            borderRadius: 8,
            background: lastFeedback.isCorrect ? "#e0ffe0" : "#fff0f0"
          }}
        >
          {lastFeedback.isCorrect ? (
            <b style={{ color: "#228833" }}>Correct!</b>
          ) : (
            <div>
              <b style={{ color: "#c33" }}>Not quite right:</b>
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                {lastFeedback.errors.map((err, idx) => (
                  <li key={idx}>{err}</li>
                ))}
              </ul>
              <div
                style={{
                  marginTop: 5,
                  fontStyle: "italic",
                  color: "#444"
                }}
              >
                <b>Sample answer:</b>{" "}
                <span style={{ color: "#227" }}>{lastFeedback.sample}</span>
              </div>
              <button
                className="button1"
                style={{ marginTop: 8 }}
                onClick={() => {
                  setUserInput("");
                  if (typeof window !== "undefined" && window.document) {
                    document.querySelector("input.quiz-input")?.focus();
                  }
                  if (typeof setLastFeedback === "function")
                    setLastFeedback(null);
                }}
              >
                Try Again
              </button>
            </div>
          )}
        </div>
      )}
      <p className="quiz-score-display">
        Score: {currentScore}/{quizLength}
      </p>
    </div>
  );
}

export function StoryModeIdentify({
  cQ,
  onSubmit,
  currentScore,
  quizLength,
  user,
  lastFeedback,
  setLastFeedback
}) {
  const [userInput, setUserInput] = useState("");
  function handleSubmit() {
    onSubmit(userInput);
  }
  return (
    <div className="quick-quiz-story-mode">
      <div className="quiz-top-panel">
        <div className="teacher-image-container">
          <img
            src="/images/teacher.png"
            alt="Teacher"
            className="quiz-character-img"
          />
        </div>
        <div className="quiz-question-box">
          <p className="quiz-question-text">{cQ.question}</p>
        </div>
      </div>
      <div className="quiz-bottom-panel">
        <div className="quiz-answer-box-left">
          <p>Type answers separated by commas</p>
          <input
            type="text"
            value={userInput}
            onChange={e => setUserInput(e.target.value)}
            placeholder="e.g. children, playground, songs"
            className="quiz-input"
            disabled={lastFeedback && !lastFeedback.isCorrect}
          />
          <button
            className="quiz-answer-btn"
            onClick={handleSubmit}
            disabled={lastFeedback && !lastFeedback.isCorrect}
          >
            Submit
          </button>
        </div>
        <div className="student-image-container">
          <img
            src={user?.avatar ?? defaultProfile}
            alt="Student"
            className="quiz-character-img-student"
          />
        </div>
      </div>
      {lastFeedback && (
        <div
          style={{
            marginTop: 8,
            padding: 8,
            borderRadius: 8,
            background: lastFeedback.isCorrect ? "#e0ffe0" : "#fff0f0"
          }}
        >
          {lastFeedback.isCorrect ? (
            <b style={{ color: "#228833" }}>Correct!</b>
          ) : (
            <>
              <b style={{ color: "#c33" }}>Not quite.</b>
              <div>{lastFeedback.message}</div>
              <div>
                <b>Correct answer(s):</b> {cQ.correctAnswers.join(", ")}
              </div>
              <button
                className="button1"
                style={{ marginTop: 8 }}
                onClick={() => setLastFeedback(null)}
              >
                Try Again
              </button>
            </>
          )}
        </div>
      )}
      <p className="quiz-score-display">
        Score: {currentScore}/{quizLength}
      </p>
    </div>
  );
}

export function StoryModeMultiPart({
    cQ,
    onAnswerClick,
    currentScore,
    quizLength,
    user,
    lastFeedback,
    setLastFeedback
  }) {
    const [speakerAns, setSpeakerAns] = useState("");
    const [moodAns, setMoodAns] = useState("");
  
    function handleSubmit() {
      if (speakerAns && moodAns) {
        onAnswerClick({ speaker: speakerAns, mood: moodAns });
      }
    }
  
    return (
      <div className="quick-quiz-story-mode">
        <div className="quiz-top-panel">
          <div className="teacher-image-container">
            <img src="/images/teacher.png" alt="Teacher" className="quiz-character-img" />
          </div>
          <div className="quiz-question-box">
            <p className="quiz-question-text">{cQ.question}</p>
          </div>
        </div>
        <div className="quiz-bottom-panel">
          <div>
            <label><b>Speaker:</b></label>
            {cQ.options.speaker.map((o, idx) => (
              <button
                key={idx}
                className={`quiz-answer-btn${speakerAns === o ? " selected" : ""}`}
                onClick={() => setSpeakerAns(o)}
                disabled={lastFeedback && !lastFeedback.isCorrect}
              >
                {o}
              </button>
            ))}
          </div>
          <div>
            <label><b>Mood:</b></label>
            {cQ.options.mood.map((o, idx) => (
              <button
                key={idx}
                className={`quiz-answer-btn${moodAns === o ? " selected" : ""}`}
                onClick={() => setMoodAns(o)}
                disabled={lastFeedback && !lastFeedback.isCorrect}
              >
                {o}
              </button>
            ))}
          </div>
          <button
            className="quiz-answer-btn"
            onClick={handleSubmit}
            disabled={!(speakerAns && moodAns) || (lastFeedback && !lastFeedback.isCorrect)}
          >
            Submit
          </button>
        </div>
        {lastFeedback && (
          <div
            style={{
              marginTop: 8,
              padding: 8,
              borderRadius: 8,
              background: lastFeedback.isCorrect ? "#e0ffe0" : "#fff0f0"
            }}
          >
            {lastFeedback.isCorrect ? (
              <b style={{ color: "#228833" }}>Correct!</b>
            ) : (
              <>
                <b style={{ color: "#c33" }}>Not quite.</b>
                <div>
                  The correct answer was: <b>{`${cQ.correctAnswer.speaker}, ${cQ.correctAnswer.mood}`}</b>
                </div>
                <button
                  className="button1"
                  style={{ marginTop: 8 }}
                  onClick={() => setLastFeedback(null)}
                >
                  Try Again
                </button>
              </>
            )}
          </div>
        )}
        <p className="quiz-score-display">
          Score: {currentScore}/{quizLength}
        </p>
      </div>
    );
  }
  
export function FinalQuiz({ cQ, fIdx, finalQs, handleFinalAnswer, fScore, grade }) {
    const [input, setInput] = useState("");
    const [speakerAns, setSpeakerAns] = useState("");
    const [moodAns, setMoodAns] = useState("");
  
    useEffect(() => {
      setInput("");
      setSpeakerAns("");
      setMoodAns("");
    }, [fIdx]);
  
    if (!cQ) return <div>Loading...</div>;
  
    // Advanced (Grade 8-12+) support for MC_MULTI, or future types
    if (grade >= 8 && cQ.questionType === "MC_MULTI" && cQ.options && cQ.correctAnswer) {
      return (
        <div>
          <p>
            Q {fIdx + 1}/{finalQs.length}: {cQ.question}
          </p>
          <div>
            <b>Speaker:</b>
            {cQ.options.speaker.map((o, i) => (
              <button
                key={i}
                className={`button1${speakerAns === o ? " selected" : ""}`}
                onClick={() => setSpeakerAns(o)}
              >
                {o}
              </button>
            ))}
          </div>
          <div>
            <b>Mood:</b>
            {cQ.options.mood.map((o, i) => (
              <button
                key={i}
                className={`button1${moodAns === o ? " selected" : ""}`}
                onClick={() => setMoodAns(o)}
              >
                {o}
              </button>
            ))}
          </div>
          <button
            className="button1"
            style={{ marginTop: 8 }}
            disabled={!speakerAns || !moodAns}
            onClick={() => handleFinalAnswer({ speaker: speakerAns, mood: moodAns })}
          >
            Submit
          </button>
          <p>Score: {fScore}</p>
        </div>
      );
    }
  
    // Default: MC, FITB, IDENTIFY (works for all grades)
    return (
      <div>
        <p>
          Q {fIdx + 1}/{finalQs.length}: {cQ.question}
        </p>
        {cQ.questionType === "MC" && cQ.options && (
          cQ.options
            .filter(o => !!o && o.trim() !== "")
            .map((o, i) => (
              <button key={i} className="button1" onClick={() => handleFinalAnswer(o)}>
                {o}
              </button>
            ))
        )}
        {(cQ.questionType === "FITB" || cQ.questionType === "IDENTIFY") && (
          <form
            onSubmit={e => {
              e.preventDefault();
              handleFinalAnswer(input);
            }}
          >
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder={
                cQ.questionType === "IDENTIFY"
                  ? "Type answers separated by commas"
                  : "Type your answer"
              }
              style={{ minWidth: 240 }}
              autoFocus
            />
            <button className="button1" type="submit">
              Submit
            </button>
          </form>
        )}
        <p>Score: {fScore}</p>
        <br />
      </div>
    );
  }
